"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formTriggerStatuses = exports.formTriggerTypes = exports.formScheduleIntervals = exports.formScheduleTypes = exports.formStatuses = exports.formAssignmentStatuses = void 0;
exports.formAssignmentStatuses = ['CREATED', 'ASSIGNED', 'SUBMITTED', 'EXPIRED'];
exports.formStatuses = ['ACTIVE', 'INACTIVE'];
exports.formScheduleTypes = ['FIXED', 'PERIODIC'];
exports.formScheduleIntervals = ['DAY', 'MONTH', 'QUARTER', 'YEAR'];
exports.formTriggerTypes = ['DISTRIBUTE', 'EXPIRE'];
exports.formTriggerStatuses = ['RUNNING', 'COMPLETED', 'FAILED'];
//# sourceMappingURL=Forms.js.map